import { cn } from '@/shared/lib'
import { Icon } from '@/shared/ui/icon'

interface SlotsMeterProps {
  busy: number
  // Знаменатель — факт юнита из heartbeat'а; plan — ёмкость по плану CP.
  total: number
  plan?: number
  onGradient?: boolean
  className?: string
}

export function SlotsMeter({ busy, total, plan, onGradient = false, className }: SlotsMeterProps) {
  const ratio = total > 0 ? Math.min(1, busy / total) : 0
  const drift = plan !== undefined && plan !== total

  return (
    <div className={cn('flex items-center gap-2', className)}>
      {/* biome-ignore lint/a11y/useSemanticElements: нативный <meter> не стилизуется под токен-слой */}
      <div
        className={cn(
          'h-1.5 flex-1 overflow-hidden rounded-full',
          onGradient ? 'bg-black/30' : 'bg-raise',
        )}
        role="meter"
        aria-valuemin={0}
        aria-valuemax={total}
        aria-valuenow={busy}
        aria-label={`Занято ${busy} из ${total}`}
      >
        <div
          className={cn('h-full rounded-full', onGradient ? 'bg-white/80' : 'bg-accent')}
          style={{ width: `${ratio * 100}%` }}
        />
      </div>
      <span className={cn('shrink-0 text-caption', onGradient ? 'text-white/80' : 'text-muted')}>
        {busy}/{total}
      </span>
      {drift && (
        <span
          className={cn(
            'inline-flex shrink-0 items-center gap-1 text-caption',
            onGradient ? 'text-white' : 'text-warn',
          )}
          title={`План CP: ${plan}, факт юнита: ${total}`}
        >
          <Icon name="alert" size={12} />
          план {plan}
        </span>
      )}
    </div>
  )
}
